import request from "@/utils/request.js";

export function getCityInfo() {
  return request({
    url:"/api/index/ipinfo",
    method: "get"
  });
}

export function getIp(ip) {
  return request({
    // url:`https://qifu-api.baidubce.com/ip/local/geo/v1/district`,
    // url:"https://www.ipplus360.com/getIP",
    // url:`https://qifu-api.baidubce.com/ip/local/geo/v1/district?ip=${ip}`,
    // url:'https://api.ipify.org?format=json',
    url:'https://api.ipify.org/?format=jsonp&callback=getIP',
    method: "get",

  });
}


export function getBaiduIp(ip) {
  return request({
    url:`https://qifu-api.baidubce.com/ip/local/geo/v1/district`,
    // url:"https://www.ipplus360.com/getIP",
    // url:`https://qifu-api.baidubce.com/ip/local/geo/v1/district?ip=${ip}`,
    // url:'https://api.ipify.org?format=json',
    // url:'https://api.ipify.org/?format=jsonp&callback=getIP',
    method: "get",

  });
}


//获取详情
export function getPageInfo(data) {
  return request({
    url:"/api/index/getlandingpageinfo",
    method: "post",
    data: data
  });
}

export function addOrder(data) {
  return request({
    url:"/api/index/order_add",
    method: "post",
    data:data
  });
}

export function addOrderWX(data) {
  return request({
    url:"/api/index/online_pay",
    method: "post",
    data:data
  });
}


export function getConfig(query) {
  return request({
    url:"/api/index/getconfig",
    method: "post",
    data:query
  });
}

//发送短信
export function getMsgCode(data) {
  return request({
    url:"/api/index/send_sms",
    method: "post",
    data: data
  });
}

//发送短信
export function checkMsgCode(data) {
  return request({
    url:"/api/index/checkcode",
    method: "post",
    data: data
  });
}

//新版获取详情
export function getNewPagePddInfo(data) {
  return request({
    url:"/api/index/newgetlandingpageinfo",
    method: "post",
    data: data
  });
}

//获取详情
export function getPagePddInfo(data) {
  return request({
    url:"/api/index/getlandingpagepddinfo",
    method: "post",
    data: data
  });
}

//提交code参数，跳转时调用
export function submitCode(data) {
  return request({
    url:"/api/index/addsubmit",
    method: "post",
    data: data
  });
}

//提交code参数，跳转时调用
export function submitJump(data) {
  return request({
    url:"/api/index/jumplog",
    method: "post",
    data: data
  });
}

//短信通道西单
export function smsAddOrder(data) {
  return request({
    url:"/api/index/sms_order",
    method: "post",
    data:data
  });
}


//记录数据
export function smsSetLog(data) {
  return request({
    url:"/api/index/smslog",
    method: "post",
    data:data
  });
}


export function goGdtWx() {
  return request({
    url:"/gdt/promotion/toIndex",
    method: "get"
  });
}

//新版获取详情
export function getNewLandingPageInfo(data) {
  return request({
    url:"/api/index/firstgetlandingpageinfo",
    method: "post",
    data: data
  });
}

//获取是否表单
export function getSecondLandingPageInfo(data) {
  return request({
    url:"/api/index/secondgetlandingpageinfo",
    method: "post",
    data: data
  });
}

//新页面（是否展示表单）
export function getNotLanginPage(data) {
  return request({
    url:"/api/index/nomidelgetlangingpageinfo",
    method: "post",
    data: data
  });
}


//没有拼多多新页面（是否展示表单）
export function getNotPddLanginPage(data) {
  return request({
    url:"/api/index/nopddgetlangingpageinfo",
    method: "post",
    data: data
  });
}



//首页列表
export function getHomeGoods(data) {
  return request({
    url:"/api/Index/getgoodslist",
    method: "post",
    data: data
  });
}

//首页使用获取商品详情
export function getHomeGoodsDetail(data) {
  return request({
    url:"/api/Index/detailgetlandingpageinfo",
    method: "post",
    data: data
  });
}



export function getPayResult(data) {
  return request({
    url:`/api/index/query_pay_result?out_trade_no=${data.out_trade_no}&product_code=${data.product_code}`,
    method: "get",
  });
}

export function getWXPayResult(data) {
  return request({
    url:`/api/index/wx_query_pay_result?out_trade_no=${data.out_trade_no}&product_code=${data.product_code}`,
    method: "get",
  });
}


export function getWXYPLPayResult(data) {
  return request({
    url:`/api/index/efpsquerypayresult?order_no=${data.order_no}`,
    method: "get",
  });
}


export function getShopGoods(data) {
  return request({
    url:`api/index/getshopinfo`,
    method: "post",
    data: data
  });
}



//账号注册
export function register(data) {
  return request({
    url:`api/login/register`,
    method: "post",
    data: data
  });
}
//登录
export function login(data) {
  return request({
    url:`api/login/h5account`,
    method: "post",
    data: data
  });
}

//订单列表
export function orderList(data) {
  return request({
    url:`api/User/getorder`,
    method: "post",
    data: data
  });
}


export function ceshisku(data) {
  return request({
    url:`adminapi/product.ProductSpecs/add`,
    method: "post",
    data: data
  });
}



//获取百度二跳信息
export function getPagePddInfoBd(data) {
  return request({
    url:"/api/index/getlandingpagepddinfo_bd",
    method: "post",
    data: data
  });
}

//申请售后
export function orderAfter(data) {
  return request({
    url:"/api/user/orderrefund",
    method: "post",
    data: data
  });
}

//立即支付
export function orderNowPay(data) {
  return request({
    url:"/api/index/continue_pay",
    method: "post",
    data:data
  });
}

//用户联系方式录入
export function setUserInfo(data) {
  return request({
    url:"/api/Infororder/add",
    method: "post",
    data:data
  });
}



// WEBPACK FOOTER //
// ./src/utils/api.js